import {
    CourseOrderLocalItemResult,
    UpdateCourseOrderISBNRequest
} from "../../../../../../../../services/courseOrder/models/CourseOrderType";
import {useTranslation} from "react-i18next";
import Accordion from "../../../../../../../../components/blocks/Accordion";
import AccordionItem from "../../../../../../../../components/blocks/Accordion/AccordionItem";
import FormInput from "../../../../../../../../components/blocks/FormInput";
import DatePicker from "../../../../../../../../components/blocks/DatePicker";
import AttachmentCard from "../../../../../../../../components/blocks/AttachmentCard";
import {useEffect, useState} from "react";
import FileUploadWithPreview, {
    SelectedFilesType
} from "../../../../../../../../components/blocks/FileUploadWithPreview";
import {TaskActionsNames} from "../../../../../../../../services/shared-models/sharedTypes";
import {OpenPublishingTaskResult} from "../../../../../../../../services/tasks/models/tasksTypes";
import {BackendServices} from "../../../../../../../../services";

export const ISBNFromSection = ({ order ,submitRef}: { order: CourseOrderLocalItemResult | null , submitRef:any;}) => {
    const { t } = useTranslation("Orders");
    const [ISBMState , setISBNState ] = useState<UpdateCourseOrderISBNRequest>({
        iSBN :order?.isbn,
        iSBNRequestedDate: new Date(order?.isbnRequestedDate??new Date()),
        iSBNFiles: order?.isbnFiles?.map(i=>i.id),
        iSBNContractId: order?.isbnContractId
       
    })
    const [error, setError] = useState<boolean>(false);
    const [ISBNFiles, setISBNFiles] = useState<SelectedFilesType[]>([]);
    const [ISBNContract, setISBNContract] = useState<SelectedFilesType[]>([]);
    useEffect(() => {
        setISBNState({
            iSBN :order?.isbn,
            iSBNRequestedDate: new Date(order?.isbnRequestedDate??new Date()),
            iSBNFiles: order?.isbnFiles?.map(i=>i.id),
        });
        
        setISBNFiles(
      order?.isbnFiles?.map((file) => ({
            file: new File([], file.name ?? ""),
            fileName: file.name ?? "",
            uuid: file.id.toString(),
            size: file.size,
        }))??[]
       );
            setISBNContract(
                order?.isbnContract ? [{
                    file: new File([], order?.isbnContract.name ?? ""),
                    fileName: order?.isbnContract.name ?? "",
                    uuid: order?.isbnContract.id.toString(),
                    size: order?.isbnContract.size,
                }] : []
            );
            
    },[order])

    useEffect(() => {
        if(ISBMState?.iSBNFiles?.length !==0)
        {
            setError(false);
        }
        submitRef.current = {
            globalSubmit:async (actionName: TaskActionsNames,openTask: OpenPublishingTaskResult | null,notes?:string ) :Promise<number>=>{
                if(actionName ==="Complete" )
                {
                    console.log(ISBMState);
                    if(ISBMState?.iSBNFiles?.length ===0)
                    {
                        setError(true);
                        return -1;  
                    }
                    const res= await BackendServices.courseOrderService.updateCourseOrderISBN(order?.id??0, ISBMState);
                    if(res.hasError)
                    {
                        console.log(res.description);
                    }
                    return 0;
                }
                return 0;



            }
        };
    },[ISBMState]);
    

    return (
        <Accordion>
            <AccordionItem initiallyOpen title={t("PublishingHouse")} elementId={"PublishingHouse"}>
                <div className="d-flex gap-2 flex-wrap">
                    <FormInput
                        label={t("rdmk")}
                        value={ISBMState?.iSBN}
                        onChange={(e) => setISBNState({...ISBMState, iSBN: e.target.value})}
                    />
                    <DatePicker value={ISBMState?.iSBNRequestedDate?? new Date} label={t("rdmkRequestDate")} 
                                onChange={(date)=>setISBNState( {...ISBMState, iSBNRequestedDate: date})} 
                    />
                </div>

                <div className="pt-4">
                    <div className="d-flex gap-3 mt-2 ">
                        <FileUploadWithPreview
                            label={t("Attachthefinalversion")}
                            files={ISBNFiles}
                            setFiles={setISBNFiles}
                            isMultiple={true}
                            onChange={(files) => {
                                setISBNState({... ISBMState, iSBNFiles: files.map((x) => x?.uuid)});
                            }}
                            onDelete={(files) => {
                                setISBNState({... ISBMState, iSBNFiles: files.map((x) => x?.uuid)});
                            }}
                        />

                    </div>
                    {error && <div className={"invalid-feedback d-block"}> {t("You must add 1 file at least")} </div>}
                </div>
                <div className="pt-4">
                    <div className="d-flex gap-3 mt-2 ">
                        <FileUploadWithPreview
                            label={t("AttachContract")}
                            files={ISBNContract }
                            setFiles={setISBNContract}
                            isMultiple={false}
                            onChange={(files) => {
                                console.log(files);
                                // setISBNContract([files[0]])
                                setISBNState({... ISBMState, iSBNContractId: files.length > 0 ? files[0]?.uuid : undefined});
                            }}
                            onDelete={(files) => {
                                setISBNState({... ISBMState, iSBNContractId: files.length > 0 ? files[0]?.uuid : undefined});
                            }}
                        />

                    </div>
                    {error && <div className={"invalid-feedback d-block"}> {t("You must add 1 file at least")} </div>}
                </div>  
                <div className="divider mt-4 "></div>
            </AccordionItem>
        </Accordion>
    );
};
